import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {firstValueFrom, map, Observable} from 'rxjs';
import { ConfigService } from './config/config.service';
import { BimModel } from '../bim-viewer/src/lib/models/bim.model';
import { BimSection, PlanDto } from './models/plan';

@Injectable({providedIn: 'root'})
export class BpApiService {
  private readonly apiUrl;

  constructor(private http: HttpClient, private bpConfigService: ConfigService) {
    this.apiUrl = this.bpConfigService.getConfig().bpApiUrl;

  }


  public getDefaultModel(): Observable<BimModel[]> {
    const api = this.apiUrl + '/bim-models?default=true';
    return this.http.get<BimModel[]>(api);
  }

  // bim plan extends plan contain transform object

  public getBimSections(bimModelId: string): Observable<BimSection[]> {
    const api = this.apiUrl + `bim-models/${bimModelId}/floor-plans?details=true`;
    const bimSections = this.http.get<BimSection[]>(api);
    return bimSections;
  }


  public getPlans(projectId: string): Observable<PlanDto[]> {
    const url = this.apiUrl + `plans`;
    return this.http.get<PlanDto[]>(url)
    .pipe(
      map(plans=> {
        const plansWithVersion = []
        plans.forEach(p=> {
          if (p.versions?.length>0) {
            p.activeVersion = p.versions[p.versions.length-1];
            plansWithVersion.push(p);
          }

        })
        return plansWithVersion;
      }
      )
    );
  }
}
